import React, {Component} from "react"
import {connect} from "react-redux"
import styled from "styled-components"
import {
    ContainerLeft,
    ContainerRight,
    Loader,
    Page,
    Tabs,
} from "components/layouts"
import {
    Heading,
    Text,
} from "components/styled"
import {
    CircularProgressBar,
    MapProjects,
    Timeline,
} from "components/visualization"
import {images} from "config/index"
import FeedbackItem from "./feedback/feedback-item"
import {
    commonLocalization,
    currency,
    detailLocalization,
    number,
} from "localization"
import {Link} from "react-router-dom"
import ScrollArea from "react-scrollbar"
import {
    Box,
    Flex,
} from "grid-styled"
import infraMonitorService from "api/infraMonitorService"
import {media} from "../../../components/styled/utils"
import {getMunData} from "utils"

const data = getMunData()

class ProjectDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedTab: "monitoring",
            leftSectionWidth: 0,
            rightSectionWidth: 0,
            id: 0,
            detail: {},
            loading: true,
        }
        this.ref = React.createRef()
        this.municipality = props.municipality
    }

    componentDidMount() {
        const leftSectionWidth =
            this.ref.current && this.ref.current.getBoundingClientRect().width
        this.setState({
            leftSectionWidth,
        })

        infraMonitorService
            .getProjectDetail(this.props.match.params.id, this.municipality.title_en)
            .then(response => {
                this.setState({
                    detail: response.data,
                    loading: false,
                })
            })
            .catch(response => {
                this.setState({
                    loading: false,
                })
            })
    }

    downloadOurApp = () => {
        if (this.props.selectedLanguage === "en") {
            return (
                <li>
                    <span>1</span>
                    Go to Google Playstore and{" "}
                    <a
                        href={data.apkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        download
                    </a>{" "}
                    the Infrastructure Management System ({data.contact_en.region}) app in
                    your android phone.
                </li>
            )
        }
        return (
            <li>
                <span>१</span>
                तपाईकाेे एन्ड्राेइड फाेनकाे गुगल प्लेस्टाेरमा गई Infrastructure
                Management System ({data.contact_en.region}) एप
                <a
                    href={data.apkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {" "}
                    डाउनलाेड{" "}
                </a>
                गर्नुहाेस् ।
            </li>
        )
    }

    onTabChange = val => {
        this.setState({selectedTab: val})
    }

    render() {
        const {selectedLanguage} = this.props

        const {
            title,
            title_en,
            wards,
            cost_estimate_without_vat: estimatedBudget,
            agreement_amount_without_vat: totalBudget,
            financial_progress: financialProgress = 0,
            physical_progress: physicalProgress = 0,
            status,
            no_of_bidders: totalBidders,
            name_of_contractor: nameOfContractor,
            feedbacks,
            is_user_community,
            procurement_type,
            user_committee_members,
            projectBudgetSourceDetails
        } = this.state.detail

        const {leftSectionWidth} = this.state
        const mapSectionWidth = leftSectionWidth * 0.5

        const localizationCommon = commonLocalization[selectedLanguage]

        const localizationDetail = detailLocalization[selectedLanguage]

        const feedbackData = !feedbacks || feedbacks.length === 0 ? [] : (
            feedbacks.filter(feedback => feedback.type === this.state.selectedTab)
        )

        const userCommitteeContribution = () => {
          if (!projectBudgetSourceDetails || projectBudgetSourceDetails.length === 0) return 0;
          return  projectBudgetSourceDetails.reduce((prev, curr) => {
            if (curr.amount) {
              return (+prev) + (+curr.amount);
            }
            return prev
          }, 0)
        }

        return (
            <React.Fragment>
                {this.state.loading && <Loader/>}
                <Page>
                    <ContainerLeft>
                        <LeftSection
                            className="left-section"
                            innerRef={this.ref}
                            lang={selectedLanguage}
                        >
                            {title && (
                                <div className="main-title">
                                    {selectedLanguage === "np"
                                        ? title
                                        : title_en || title}
                                </div>
                            )}
                            <Flex
                                style={{
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginBottom: 40,
                                }}
                            >
                                <Box className="status">
                                    {status && (
                                        <Text.span className={status && status.title.toLowerCase()}>
                                            {localizationCommon[status.name].toUpperCase()}
                                        </Text.span>
                                    )}
                                </Box>
                                <Box>
                                    <Link to="/projects" className="back-to-projects">
                                       <span>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="m8 12 6-6v12l-6-6Z"/></svg>
                                       </span> 
                                       {localizationDetail.backToProjects}
                                    </Link>
                                </Box>
                            </Flex>
                            <div className="upper-chart-section detail-page-map-section">
                                <div className="map-section">
                                    <MapProjects width={mapSectionWidth} data={wards}
                                                 selectedLanguage={selectedLanguage}/>
                                </div>
                                <div className="progress-section">

                                    {!is_user_community &&
                                    <React.Fragment>


                                        <div style={{marginBottom: 10}}>
                                            <Text.span className="count">
                                                <Text.span light style={{fontSize: 16}}>
                                                    {localizationDetail.nrs}
                                                </Text.span>{" "}
                                                {currency(estimatedBudget && estimatedBudget.toFixed(0))}
                                            </Text.span>
                                            <Text.span uppercase lighter>
                                                {localizationDetail.estimatedBudget}
                                            </Text.span>
                                        </div>

                                        <div style={{marginBottom: 50}}>
                                            <Text.span className="count">
                                                <Text.span light style={{fontSize: 16}}>
                                                    {localizationDetail.nrs}
                                                </Text.span>{" "}
                                                {currency(totalBudget && totalBudget.toFixed(0))}
                                            </Text.span>
                                            <Text.span uppercase lighter>
                                                {localizationDetail.agreementAmount}
                                            </Text.span>
                                        </div>
                                    </React.Fragment>
                                    }

                                    {is_user_community &&
                                    <React.Fragment>
                                        <div style={{marginBottom: 10}}>
                                            <Text.span className="count">
                                                <Text.span light style={{fontSize: 16}}>
                                                    {localizationDetail.nrs}
                                                </Text.span>{" "}
                                                {currency(totalBudget && totalBudget.toFixed(0))}
                                            </Text.span>
                                            <Text.span uppercase lighter>
                                                {localizationDetail.allocatedBudget}
                                            </Text.span>
                                        </div>

                                        <div style={{marginBottom: 10}}>
                                            <Text.span className="count">
                                                <Text.span light style={{fontSize: 16}}>
                                                    {localizationDetail.nrs}
                                                </Text.span>{" "}
                                                {currency(estimatedBudget && estimatedBudget.toFixed(0))}
                                            </Text.span>
                                            <Text.span uppercase lighter>
                                                {localizationDetail.estimatedBudget}
                                            </Text.span>
                                        </div>

                                        <div style={{marginBottom: 50}}>
                                            <Text.span className="count">
                                                <Text.span light style={{fontSize: 16}}>
                                                    {localizationDetail.nrs}
                                                </Text.span>{" "}
                                                {currency(userCommitteeContribution()
                                                    .toFixed(0))}
                                            </Text.span>
                                            <Text.span uppercase lighter>
                                                {localizationDetail.userCommitteeContribution}
                                            </Text.span>
                                        </div>
                                    </React.Fragment>
                                    }

                                    <ProjectsCircular lang={selectedLanguage}>
                                        <div>
                                            {<CircularProgressBar value={physicalProgress}/>}
                                            <Text.span lighter uppercase>
                                                {localizationCommon.physicalProgress}
                                            </Text.span>
                                        </div>
                                        <div>
                                            {<CircularProgressBar value={financialProgress}/>}
                                            <Text.span lighter uppercase>
                                                {localizationCommon.financialProgress}
                                            </Text.span>
                                        </div>
                                    </ProjectsCircular>
                                </div>
                            </div>
                            {this.state.detail.agreement_date && (
                                <React.Fragment>
                                    <Text.span lighter uppercase className="timeline-title">
                                        {localizationDetail.projectTimeline}
                                    </Text.span>
                                    <Timeline width={leftSectionWidth} data={this.state.detail}/>
                                </React.Fragment>
                            )
                            }
                            <div className="project-detail-info">
                                <div className="wards">
                                    <Text.span className="wards-value">
                                        {wards && number(wards).toLocaleString()}
                                    </Text.span>
                                    <Text.span lighter uppercase className="wards-title">
                                        {localizationDetail.wards}
                                    </Text.span>
                                </div>

                                {(procurement_type && procurement_type.name === "tendered") && (
                                    <div className="total-bidders">
                                        <Text.span className="total-bidders-value">
                                            {currency(totalBidders)}
                                        </Text.span>
                                        <Text.span lighter uppercase className="total-bidders-title">
                                            {localizationDetail.totalBidders}
                                        </Text.span>
                                    </div>
                                )}

                                {(procurement_type 
                                  && 
                                  (procurement_type.name === "tendered" || procurement_type.name === "user_committee")) && 
                                  (<div className="name-of-contractor">
                                    <Text.span className="name-of-contractor-value">
                                        {nameOfContractor}
                                    </Text.span>
                                    <Text.span
                                        lighter
                                        uppercase
                                        className="name-of-contractor-title"
                                    >
                                        {is_user_community
                                            ? localizationDetail.nameOfUserCommittee
                                            : localizationDetail.nameOfContractor}
                                    </Text.span>
                                </div>)}
                            </div>

                            {user_committee_members && user_committee_members.length > 0 && (
                                <TableWrapper
                                    className="table-wrap"
                                    position={localizationDetail.position}
                                    name={localizationDetail.name}
                                    address={localizationDetail.address}
                                    lang={selectedLanguage}
                                >
                                    <Heading.h1 style={{fontWeight: "bold"}}>
                                        {localizationDetail.userCommitteeOfficials}
                                    </Heading.h1>

                                    <table>
                                        <thead>
                                        <tr>
                                            <th>{localizationDetail.position}</th>
                                            <th>{localizationDetail.name}</th>
                                            <th>{localizationDetail.address}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {user_committee_members &&
                                        user_committee_members.map(member => (
                                            <tr key={member.order}>
                                                <td>
                                                    {selectedLanguage === "en"
                                                        ? member.position_en
                                                        : member.position_ne}
                                                </td>
                                                <td>{member.name}</td>
                                                <td>{member.address}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </TableWrapper>
                            )}

                        </LeftSection>
                    </ContainerLeft>
                    <ContainerRight>
                        {/* <div className="feedback-wrap">
             <Feedback />
             </div> */}
                        {feedbacks && feedbacks.length > 0 && (
                            <div className="project-detail-tabs">
                                <Tabs firstTab={{value: "monitoring", className: "monitoring"}}
                                      secondTab={{value: "feedback", className: "feedback"}}
                                      selectedTab={this.state.selectedTab}
                                      onTabChange={this.onTabChange}/>
                            </div>)
                        }

                        <FeedbackList lang={selectedLanguage}>
                            <div>
                                {feedbacks && feedbacks.length > 0 ? (
                                    <div className={`feedback-list ${this.state.selectedTab}`}>
                                        <ScrollArea
                                            height={'500px'}
                                            className="options"
                                            smoothScrolling
                                            minScrollSize={30}
                                        >
                                            <React.Fragment>
                                                <FeedBackSection lang={selectedLanguage}>
                                                    <div className="feedback-wrapper">
                                                        {feedbackData.length > 0 ? (
                                                            <div className="feedback-wrapper-inner">
                                                                <div>
                                                                    <h3>{localizationDetail[this.state.selectedTab]}:</h3>
                                                                    <ul>
                                                                        {feedbackData.map((feedback, index) => (
                                                                            <FeedbackItem feedback={feedback}
                                                                                          key={index}/>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                                <div>
                                                                    <FeedbackDownload
                                                                        className="download-feedback"
                                                                        lang={selectedLanguage}
                                                                    >
                                                                        <Flex className="download-inner-feedback">
                                                                            <Box className="download-app">
                                                                                <Text.span bold uppercase
                                                                                           className="title">
                                                                                    <span style={{opacity: 0.7}}>
                                                                                      {localizationDetail.gotFeedback}
                                                                                    </span>
                                                                                </Text.span>
                                                                                <Text.span lighter>
                                                                                    {localizationDetail.downloadAndroid}
                                                                                </Text.span>
                                                                                <a
                                                                                    href={data.apkUrl}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <img
                                                                                        src={images.icons.googleBadge}
                                                                                        alt="Google Play"
                                                                                        width="130"
                                                                                    />
                                                                                </a>
                                                                            </Box>
                                                                        </Flex>
                                                                    </FeedbackDownload>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="no-feedback">
                                                                <div className="no-feedback-text">
                                                                    <Text.span uppercase lighter>
                                                                        {localizationDetail[`no${this.state.selectedTab}`]}
                                                                    </Text.span>
                                                                </div>

                                                                {this.state.selectedTab === "feedback" && (
                                                                    <FeedbackSteps lang={selectedLanguage}>
                                                                        <Heading.h3 uppercase>
                                                                            {localizationDetail.FeedbackAbout}
                                                                        </Heading.h3>
                                                                        <Text.span>{localizationDetail.feedbackText}</Text.span>
                                                                        <ol>
                                                                            {this.downloadOurApp()}
                                                                            <li>
                                                                                <span>{localizationDetail.feedbackStep2num}</span>
                                                                                {localizationDetail.feedbackStep2}
                                                                            </li>
                                                                            <li>
                                                                                <span>{localizationDetail.feedbackStep3num}</span>
                                                                                {localizationDetail.feedbackStep3}
                                                                            </li>
                                                                        </ol>
                                                                    </FeedbackSteps>
                                                                )}

                                                                <FeedbackDownload
                                                                    className="download-feedback"
                                                                    lang={selectedLanguage}
                                                                >
                                                                    <Flex className="download-inner-feedback">
                                                                        <Box className="screenshot-img">
                                                                            <img src={images.googleScreenshot}
                                                                                 alt="screenshot"/>
                                                                        </Box>
                                                                        <Box className="download-app">
                                                                            <Text.span bold uppercase className="title">
                                                                                <span style={{opacity: 0.7}}>
                                                                                  {localizationDetail.gotFeedback}
                                                                                </span>
                                                                            </Text.span>
                                                                            <Text.span lighter>
                                                                                {localizationDetail.downloadAndroid}
                                                                            </Text.span>
                                                                            <a
                                                                                href={data.apkUrl}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <img
                                                                                    src={images.icons.googleBadge}
                                                                                    alt="Google Play"
                                                                                    width="130"
                                                                                />
                                                                            </a>
                                                                        </Box>
                                                                    </Flex>
                                                                </FeedbackDownload>
                                                            </div>
                                                        )}
                                                    </div>
                                                </FeedBackSection>
                                            </React.Fragment>
                                        </ScrollArea>
                                    </div>
                                ) : (
                                    <div className="no-feedback">
                                        <div className="no-feedback-text">
                                            <Text.span uppercase lighter>
                                                {localizationDetail.nofeedback}
                                            </Text.span>
                                        </div>
                                        <FeedbackSteps lang={selectedLanguage}>
                                            <Heading.h3 uppercase>
                                                {localizationDetail.FeedbackAbout}
                                            </Heading.h3>
                                            <Text.span>{localizationDetail.feedbackText}</Text.span>
                                            <ol>
                                                {this.downloadOurApp()}
                                                <li>
                                                    <span>{localizationDetail.feedbackStep2num}</span>
                                                    {localizationDetail.feedbackStep2}
                                                </li>
                                                <li>
                                                    <span>{localizationDetail.feedbackStep3num}</span>
                                                    {localizationDetail.feedbackStep3}
                                                </li>
                                            </ol>
                                        </FeedbackSteps>
                                        <FeedbackDownload
                                            className="download-feedback"
                                            lang={selectedLanguage}
                                        >
                                            <Flex className="download-inner-feedback">
                                                <Box className="screenshot-img">
                                                    <img src={images.googleScreenshot} alt="screenshot"/>
                                                </Box>
                                                <Box className="download-app">
                                                    <Text.span bold uppercase className="title">
                                                        <span style={{opacity: 0.7}}>
                                                          {localizationDetail.gotFeedback}
                                                        </span>
                                                    </Text.span>
                                                    <Text.span lighter>
                                                        {localizationDetail.downloadAndroid}
                                                    </Text.span>
                                                    <a
                                                        href={data.apkUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img
                                                            src={images.icons.googleBadge}
                                                            alt="Google Play"
                                                            width="130"
                                                        />
                                                    </a>
                                                </Box>
                                            </Flex>
                                        </FeedbackDownload>
                                    </div>
                                )}
                            </div>
                        </FeedbackList>
                    </ContainerRight>
                </Page>
            </React.Fragment>
        )
    }
}

const FeedBackSection = styled.div`
  h3 {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    margin-left: 40px;
    padding-left: 30px;
    position: relative;
    text-transform: uppercase;

    &:before {
      background: url(${images.icons.sprite}) no-repeat -96px -63px;
      content: "";
      height: 20px;
      left: 0;
      position: absolute;
      top: ${props => (props.lang === "en" ? "1px" : "3px")};
      width: 20px;
    }
  }
`

const LeftSection = styled.div`
  padding-bottom: 30px;
  .back-to-projects {
    color: var(--color-theme-1);
    text-decoration: none;
    border-bottom: 1px solid var(--color-theme-1);
    float: right;
    font-size: ${props => (props.lang === "en" ? "12px" : "13px")};
    line-height: 16px;
    opacity: 0.7;
    position: relative;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;

    svg {
      width: 10px;
    }
    &:hover {
      opacity: 1;
    }
  }
  .projects-value {
    font-size: 42px;
    font-weight: bold;
  }
  .projects-title {
    font-size: 12px;
  }
  .bar-chart-label {
    width: ${props => `${props.width}px`};
    margin-top: 10px;
    text-align: center;
    fill: ${props => props.theme.primary.white};
    opacity: 0.5;
  }
  .status {
    display: inline-block;
    span {
      border-radius: 11px;
      color: ${props => props.theme.primary.white};
      display: block;
      font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      padding: ${props =>
    props.lang === "en" ? "4px 10px 3px" : "2px 10px 3px"};
    }
    .running, .implementation, .started  {
      background-color: ${props => props.theme.sec.blue};
    }

    span[class*="not"] {
      background-color: ${props => props.theme.dark.charcoalGrey};
    }

    .tendered {
      background-color: ${props => props.theme.sec.pink};
    }

    .pipeline, .approved {
      background-color: ${props => props.theme.sec.gray};
    }

    .completed,.completion {
      background-color: ${props => props.theme.sec.green};
    }

    .cancelled {
      background-color: ${props => props.theme.sec.red};
    }
  }
  .count + span,
  .timeline-title {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    // color: rgba(255,255,255,0.5);
  }
  .wards-title,
  .total-bidders-title,
  .name-of-contractor-title {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
  }
  /******** timeline  *********/
  .timeline-text-group {
    text:nth-of-type(1) {
      fill: ${props => props.theme.primary.white};
      font-size: 14px;
    }
    text:nth-of-type(2) {
      fill: ${props => props.theme.primary.white};
      font-size: 10px;
      opacity: 0.7;
    }
  }

  .progress-section {
    /* max-width: 340px; */
    ${media.tabletWide`width: 340px;`};
    > div:first-child {
      /* margin-bottom: 50px; */
    }
  }

  .project-detail-info {
    > div {
      padding-left: 30px;
      position: relative;
      & + div {
        margin-top: 20px;
      }
      &:before {
        background-image: url(${images.icons.sprite});
        background-repeat: no-repeat;
        content: "";
        height: 32px;
        left: 0;
        position: absolute;
        top: 7px;
      }
      span[class*="value"] {
        display: block;
        font-size: 21px;
        font-weight: bold;
      }
    }
    
    .wards,.name-of-contractor,.total-bidders{
        padding: 4px 0 0 54px;
    }
    
    .wards:before {
      background-position: -52px -145px;
      width: 23px;
    }
    .total-bidders {
      &:before {
        background-position: -57px -195px;
        width: 33px;
      }
    }
    .name-of-contractor {
      &:before {
        background-position: -56px -247px;
        width: 35px;
      }
    }
  }
  .navigate-projects {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    a {
      color: #fff;
      text-decoration: none;
    }
  }
`

const ProjectsCircular = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${media.tabletSmall`flex-direction: row;`};
  
  > div {
    margin: 0 10px;
    ${media.tabletSmall`margin: 0 12px 0 0`};
    text-align: center;
    > div {
      margin-bottom: 10px;
    }
    span {
      font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    }
  }
`

const FeedbackList = styled.div`
  padding-top: 58px;

  .no-feedback {
    ${media.tabletWide`padding-bottom: 200px`};
  }


  .no-feedback-text {
    border-bottom: 1px solid ${props => props.theme.dark.charcoalGrey};
    margin-bottom: 32px;
    padding-bottom: 50px;
    span {
      display: block;
      font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      margin-left: 80px;
      position: relative;
      width: 55%;
      &:before {
        background: url(${images.icons.sprite}) no-repeat -95px 0;
        content: "";
        height: 40px;
        left: -50px;
        position: absolute;
        top: 1px;
        width: 40px;
      }
    }
  }

  .lightbox-img-thumbnail {
    object-fit: cover;
  }

  .monitoring {
    h3 {
      &:before {
        background: url(${images.icons.progress}) no-repeat center;
        width: 16px;
        background-size: 100%;
        height: 26px;
        top: -2px;
      }
    }
    .no-feedback-text {
      ${media.tabletWide`
      display: flex;
      align-items: center;
      padding: 0;
      height: 200px;
      justify-content: center;
      margin: 0;
      border: none;`};

      span:before {
        top: 1px;
        left: -60px;
      }
    }
  }

  .feedback-wrapper-inner {
    .download-feedback {
      width: 100%;
      padding: 20px 37px;
      min-height: 124px;
    }

    .download-inner-feedback:before {
      display: none;
    }

    .download-app {
      padding: 0;
      width: 100%;

      .title {
        margin: 0;

        + span {
          display: inline-block;
          max-width: 240px;
          margin: 0;
          position: relative;
          top: 3px;
        }
      }
    }
  }

  .monitoring {
    .feedback-wrapper-inner .download-feedback {
       ${media.tabletWide`width: calc(40% - 32px);`};
    }

    .download-app {
      width: 100%;
      padding: 0;
      margin: 0;
      bottom: 0;
      position: relative;

      .title {
        width: 100%;
      }

      .title + span {
        display: inline-block;
        margin-bottom: 10px;
      }
    }
  }
`

const FeedbackDownload = styled.div`
  .download-app .title {
    font-size: ${props => (props.lang === "en" ? "24px" : "26px")};
    line-height: ${props => (props.lang === "en" ? "28px" : "30px")};
    margin: 26px 0 8px;
    width: 84%;
    @media all and (min-width: 1280px) and (max-height: 800px) {
      font-size: 22px;
      line-height: 26px;
      margin: 16px 0 8px;
    }
    & + span {
      font-size: ${props => (props.lang === "en" ? "12px" : "13px")};
    }
  }
`

const FeedbackSteps = styled.div`
  background-color: var(--color-card-bg-1);
  border-radius: 4px;
  font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
  margin: 0 auto 56px;
  padding: 30px 52px 14px;
  width: 90%;
  h3 {
    color: var(--color-link);
    font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
    margin-bottom: 24px;
    margin-left: 0;
  }
  > span {
    display: block;
    font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
    opacity: 0.7;
    margin-bottom: 36px;
  }
  ol {
    li {
      font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
      margin-bottom: 38px;
      opacity: 0.7;
      span {
         color: var(--color-link);
        display: inline-block;
        font-size: 18px;
        font-weight: bold;
        margin-left: -20px;
        width: 20px;
      }
      a {
         color: var(--color-link);
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`

const TableWrapper = styled.div`
  margin-top: 36px;
  table tr th {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    padding-bottom: 6px;
    &.asc,
    &.desc {
      background-position: ${props =>
    props.lang === "en" ? "left 21px" : "left 23px"};
    }
  }
  table tr td {
    font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
    .status {
      font-size: ${props => (props.lang === "en" ? "12px" : "13px")};
      padding: ${props => (props.lang === "en" ? "4px 10px" : "2px 10px")};
      &:empty {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    td {
      min-height: 51px;
      &:before {
        font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      }
    }

    td:nth-of-type(1):before {
      content: ${props => "'" + props.position + "'"};
    }
    td:nth-of-type(2):before {
      content: ${props => "'" + props.name + "'"};
    }
    td:nth-of-type(3):before {
      content: ${props => "'" + props.address + "'"};
    }
  }
`

const mapStateToProps = state => ({
    projects: state.infraMonitor.projects,
    fetched: state.infraMonitor.fetched,
    selectedLanguage: state.localizationReducers.selectedLanguage,
})

export default connect(mapStateToProps)(ProjectDetail)



// WEBPACK FOOTER //
// ./src/pages/project/detail/detail.js